module.exports = __webpack_public_path__ + "static/petlas-8ade06574df261a0a50eb0e7c3782844.png";